import { css, keyframes } from "dx-styles"
import type { FC } from "react"

const hover = keyframes({
  "0%, 100%": { transform: "translateY(3px) rotate(-1.2deg)" },
  "50%": { transform: "translateY(-5px) rotate(1.2deg)" },
})

const sweep = keyframes({
  "0%": { transform: "translateX(-60px)", opacity: 0 },
  "35%": { opacity: 0.75 },
  "100%": { transform: "translateX(60px)", opacity: 0 },
})

const pulse = keyframes({
  "0%, 100%": { opacity: 0.2, transform: "scale(0.94)" },
  "50%": { opacity: 0.6, transform: "scale(1.04)" },
})

const shield = css({
  position: "relative",
  display: "block",
  width: "100%",
  height: "100%",
  overflow: "visible",
})

const float = css({
  transformBox: "fill-box",
  transformOrigin: "center",
  animation: `${hover} 4.4s ease-in-out infinite`,
  "@media (prefers-reduced-motion: reduce)": { animation: "none" },
})

const glint = css({
  transformBox: "fill-box",
  animation: `${sweep} 3.8s ease-in-out infinite`,
  "@media (prefers-reduced-motion: reduce)": { animation: "none", opacity: 0 },
})

const halo = css({
  transformBox: "fill-box",
  transformOrigin: "center",
  animation: `${pulse} 5.2s ease-in-out infinite`,
  "@media (prefers-reduced-motion: reduce)": {
    animation: "none",
    opacity: 0.3,
  },
})

export const ShieldIllustration: FC = () => {
  return (
    <svg
      viewBox="0 0 220 220"
      className={shield}
      aria-hidden="true"
    >
      <defs>
        <linearGradient
          id="superpowersShieldBody"
          x1="0"
          y1="0"
          x2="0"
          y2="1"
        >
          <stop
            offset="0%"
            stopColor="#9B6BBE"
          />
          <stop
            offset="55%"
            stopColor="#7E4797"
          />
          <stop
            offset="100%"
            stopColor="#462853"
          />
        </linearGradient>
        <clipPath id="superpowersShieldClip">
          <path d="M110 24 L176 50 V108 C176 152 146 182 110 196 C74 182 44 152 44 108 V50 Z" />
        </clipPath>
      </defs>

      <circle
        className={halo}
        cx="110"
        cy="110"
        r="92"
        fill="rgba(126, 71, 151, 0.18)"
      />

      <g className={float}>
        <path
          d="M110 24 L176 50 V108 C176 152 146 182 110 196 C74 182 44 152 44 108 V50 Z"
          fill="url(#superpowersShieldBody)"
        />
        <path
          d="M110 40 L162 60 V108 C162 144 138 169 110 181 C82 169 58 144 58 108 V60 Z"
          fill="none"
          stroke="rgba(255, 255, 255, 0.35)"
          strokeWidth="3"
        />
        <path
          d="M84 110 L102 130 L140 86"
          fill="none"
          stroke="#FFFFFF"
          strokeWidth="11"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        <g clipPath="url(#superpowersShieldClip)">
          <rect
            className={glint}
            x="84"
            y="10"
            width="26"
            height="200"
            transform="rotate(18 110 110)"
            fill="rgba(255, 255, 255, 0.4)"
          />
        </g>
      </g>
    </svg>
  )
}
